"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _iframe = require("./iframe.paths");

Object.keys(_iframe).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _iframe[key];
    }
  });
});

var _iframe2 = require("./iframe.script");

Object.keys(_iframe2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _iframe2[key];
    }
  });
});

var _iframe3 = require("./iframe.utils");

Object.keys(_iframe3).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _iframe3[key];
    }
  });
});